export default __webpack_public_path__ + "images/CC.a27e698.png";